module.exports = __webpack_public_path__ + "img/nrb.d0fe5811.png";